import {
  DownloadOutlined,
  InfoCircleOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { Button, Card, DatePicker, Select, Table } from "antd";
import React, { useState } from "react";
import { FileList } from "../../../data";
import AutomationFileModal from "../../../components/automationFileModal/AutomationFileModal";
import { list } from "../upload/Uploads";
import { axiosInstance } from "../../../utils/axiosInterceptor";
import dayjs from "dayjs";

export const FileTypelist = [
  {
    id: 1,
    name: "All",
  },
  {
    id: 2,
    name: "COGS",
  },
  {
    id: 3,
    name: "Rebate",
  },
  {
    id: 4,
    name: "LocID",
  },
];

const AutoReports = ({
  AuditedFiles,
  setAuditLoading,
  auditloading,
  setAuditedFiles,
}) => {
  const [popUpOpen, setPopUpOPen] = useState(false);
  const [fileType, setFileType] = useState("All");
  const [file, setFile] = useState("");
  const [selectedFileData, setSelectedFileData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [fileData,setFileData] = useState('');

  const getSelectedFileData = async (record) => {
    setPopUpOPen(true);
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `/automationRouter/audited-files/${record.Id}/data?fileType=${record?.FileType}`
      );
      setSelectedFileData(response?.data?.data);
      setFileData(record)
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "FileName",
      key: "FileName",
      render: (text) => (
        <span className="font-medium text-gray-800">{text}</span>
      ),
    },
    {
      title: "Uploaded By",
      dataIndex: "UploadedBy",
      key: "UploadedBy",
      // sorter: true,
    },
    {
      title: "Upload Time",
      dataIndex: "UploadedAt",
      key: "UploadedAt",
      render: (text) => {
        const date = new Date(text);
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month (1–12)
        const day = String(date.getDate()).padStart(2, "0"); // Day (1–31)
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      },
      // sorter: true,
    },
    {
      title: "File Type",
      dataIndex: "FileType",
      key: "FileType",
      // sorter:true
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      // sorter: true,
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <div className="flex gap-2">
          <Button
            onClick={() => {
              setFile(record.FileType);
              getSelectedFileData(record);
            }}
          >
            View
          </Button>
        </div>
      ),
    },
  ];
  const updateFileType = (e) => {
    setFileType(e);
  };
  function formatDate(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const filterData =
    fileType === "All"
      ? AuditedFiles
      : AuditedFiles.filter((item) => item.FileType === fileType);


  const handleFilter = async () => {
    setAuditLoading(true);
    try {
      const response = await axiosInstance.get(
        `/automationRouter/audited-files?startDate=${formatDate(
          fromDate
        )}&endDate=${formatDate(toDate)}`
      );
      setAuditedFiles(response?.data);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setAuditLoading(false);
    }
  };

  return (
    <div>
      <Card
        title={
          <div className="flex justify-between items-center">
            <span className="font-semibold text-[16px] leading-[100%] tracking-[0%] text-justify text-[#000833]">
              Processed Files
            </span>
            <div className="flex items-center gap-4">
              <div className="-mr-1">
                <InfoCircleOutlined className="mr-2" />
                <MoreOutlined />
              </div>
            </div>
          </div>
        }
      >
        <div className="flex flex-col md:justify-between sm:flex-row sm:flex-wrap gap-4 w-full md:w-auto">
          <Select
            // mode="multiple"
            value={fileType}
            onChange={updateFileType}
            className="w-full md:w-[300px] "
            style={{
              // width: "400px",
              border: "1px solid #d9d9d9",
              "border-radius": "6px",
            }}
            placeholder="Select FileType"
            options={FileTypelist?.map((i) => ({
              label: i.name || i.name,
              value: i.name || i.name,
              key: i.id,
            }))}
            // showSearch
            maxTagCount={3}
          />

          <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center gap-4 mb-4">
            <div className="flex md:m-0 w-full">
              <div className="flex gap-1 w-full md:justify-center align-middle justify-start mr-4">
                <span className="font-medium text-gray-600">From</span>
                <DatePicker
                  placeholder="From Date"
                  value={fromDate ? dayjs(fromDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const jsDate = new Date(date.toDate());
                      jsDate.setHours(0, 0, 0, 0);
                      setFromDate(jsDate);
                    }
                  }}
                  format="MM-DD-YYYY"
                  className="w-full "
                />
              </div>
              <div className="flex flex-row w-full gap-1 justify-center align-middle">
                <span className=" font-medium text-gray-600">To</span>

                <DatePicker
                  placeholder="To Date"
                  value={toDate ? dayjs(toDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const jsDate = new Date(date.toDate());
                      jsDate.setHours(23, 59, 59, 999);
                      setToDate(jsDate);
                    }
                  }}
                  format="MM-DD-YYYY"
                  className="w-full "
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 w-full  md:w-auto">
              <div className="gap-2 flex flex-row md:justify-between justify-start w-full md:w-[100px]">
                <Button
                  type="primary"
                  // icon={<filter />}
                  onClick={handleFilter}
                  className="w-full md:w-[200px]  md:mt-0"
                >
                  Filter
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Table
          columns={columns}
          dataSource={filterData}
          loading={auditloading}
          scroll={{ x: "max-content" }}
          rowKey="id"
          size="middle"
          className="custom-table user-tbl"
          pagination={false}
        />
      </Card>
      <AutomationFileModal
        open={popUpOpen}
        hide={() => setPopUpOPen(false)}
        fileType={file}
        selectedFileData={selectedFileData}
        isLoading={isLoading}
        fileData={fileData}
      />
    </div>
  );
};

export default AutoReports;
